var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaceOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0001 13C13.9331 13 15.5001 11.433 15.5001 9.5C15.5001 7.567 13.9331 6 12.0001 6C10.0671 6 8.50006 7.567 8.50006 9.5C8.50006 11.433 10.0671 13 12.0001 13ZM12.0001 11.2C12.9389 11.2 13.7001 10.4389 13.7001 9.49999C13.7001 8.5611 12.9389 7.79999 12.0001 7.79999C11.0612 7.79999 10.3001 8.5611 10.3001 9.49999C10.3001 10.4389 11.0612 11.2 12.0001 11.2Z",
    fill: "#023F80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.24292 9.76987C4.24292 5.48026 7.71434 2 12.0001 2C16.2858 2 19.7572 5.48026 19.7572 9.76987C19.7572 12.903 17.7831 16.6225 14.1925 20.8679C14.0894 20.9898 13.9763 21.1029 13.8544 21.206C12.6435 22.2301 10.8317 22.0787 9.80764 20.8679L9.24056 20.1974L9.24632 20.1923C6.01178 16.2269 4.24292 12.7357 4.24292 9.76987ZM11.1851 19.7091C11.5677 20.1576 12.2414 20.2128 12.692 19.8317C12.7374 19.7932 12.7797 19.751 12.8181 19.7055C16.3633 15.5139 17.9572 12.2221 17.9572 9.76987C17.9572 6.47123 15.2885 3.8 12.0001 3.8C8.7116 3.8 6.04292 6.47123 6.04292 9.76987C6.04292 12.2221 7.63679 15.5139 11.182 19.7055L11.1851 19.7091Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceOutline);
export default __webpack_public_path__ + "static/media/place_outline.536ad39cd7fcb8fb0973b244620e27c9.svg";
export { ForwardRef as ReactComponent };